import { FOXIA_BLOG_API } from "@/api/api-endpoint";
import type { IFilter } from "@/interfaces/common/BaseEntity";
import type {
  FoxiaBlog,
  FoxiaBlogCreate,
} from "@/interfaces/foxia-blog.interface";
import type { CountResponse } from "@/core/network/NodeResponse";
import { request, type RequestCancellation } from "@/repositories/repositoryRequest";

class FoxiaBlogRepo {
  getListBlog(filter?: IFilter, cancelToken?: RequestCancellation) {
    const path = FOXIA_BLOG_API.FOXIA_BLOGS();
    return request<CountResponse<FoxiaBlog[]>>(
      {
        method: "GET",
        url: path,
        params: filter,
      },
      cancelToken,
    );
  }

  detailBlog(idOrSlug: number | string, cancelToken?: RequestCancellation) {
    // If a string that is not a number is passed, treat it as a slug
    const isSlug = typeof idOrSlug === 'string' && isNaN(Number(idOrSlug));
    const path = isSlug
      ? FOXIA_BLOG_API.FOXIA_BLOGS(idOrSlug) // slug as path segment
      : FOXIA_BLOG_API.FOXIA_BLOGS(idOrSlug);
    return request<FoxiaBlog>(
      {
        method: "GET",
        url: path,
      },
      cancelToken,
    );
  }

  deleteBlog(id: number | string, cancelToken?: RequestCancellation) {
    const path = FOXIA_BLOG_API.FOXIA_BLOGS(id);
    return request<unknown>(
      {
        method: "DELETE",
        url: path,
      },
      cancelToken,
    );
  }

  createBlog(data: FoxiaBlogCreate, cancelToken?: RequestCancellation) {
    const path = FOXIA_BLOG_API.FOXIA_BLOGS();
    return request<FoxiaBlog>(
      {
        method: "POST",
        url: path,
        data,
      },
      cancelToken,
    );
  }

  updateBlog(
    data: FoxiaBlogCreate,
    id: number | string,
    cancelToken?: RequestCancellation,
  ) {
    const path = FOXIA_BLOG_API.FOXIA_BLOGS(id);
    return request<FoxiaBlog>(
      {
        method: "PUT",
        url: path,
        data,
      },
      cancelToken,
    );
  }
}

export default new FoxiaBlogRepo();
